import React, { useState } from 'react';
import { TimePicker } from 'antd';
import 'antd/dist/antd.css'; // Asegúrate de importar los estilos de Ant Design

const TimePickerItem = ({ label, onChange, format = 'HH:mm', sinBorde = false, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '16px',
    },
    label: {
      color: 'black',
      textAlign: 'center',
      fontSize: '13px',
      borderRadius: '1px',
      marginTop: '6px',
      margin: '3px',
    },
    timepicker: {
      color: props.disabled ? "black" : null,
      backgroundColor: props.disabled ? "white" : null,
      borderBottom: props.sinBorde ? null : "1px solid #DADADA",
      border: props.sinBorde ? null : "1px solid #DADADA",
      borderRadius: 0,
      ...(isFocused && { borderColor: '#1890ff' }),
    },
    boxItem: {
      borderTop: '2px solid #00b5e2',
      borderRadius: '1px',
      padding: '5px',
      margin: '0px 10px',
    },
  };

  return (
    <TimePicker
      {...props}
      onChange={onChange}
      format={format}
      style={styles.timepicker}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};

export default TimePickerItem;
